var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$currentUser.role == "account"
      ? _c("div", { staticClass: "main-content bg-white" }, [
          _c("span", { staticClass: "alert-danger" }, [
            _vm._v("У вас нет доступа к этой странице.")
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.$currentUser.role != "account"
      ? _c("div", { staticClass: "main-content bg-white" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-2" }, [
            _c(
              "div",
              { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
              [
                _c("v-select", {
                  attrs: {
                    options: _vm.isTestOptions,
                    searchable: false,
                    clearable: false,
                    placeholder: "Тест"
                  },
                  model: {
                    value: _vm.isTest,
                    callback: function($$v) {
                      _vm.isTest = $$v
                    },
                    expression: "isTest"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                key: _vm.dateRange,
                staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2"
              },
              [
                _vm.isXl
                  ? _c(
                      "b-button-group",
                      { staticClass: "datePickerXl" },
                      [
                        _c("vue-rangedate-picker", {
                          attrs: {
                            value: _vm.range,
                            placeholder: "select",
                            months: _vm.months,
                            shortDays: _vm.shortDays,
                            captions: _vm.captions,
                            format: "DD.MM.YY",
                            presetRanges: _vm.ranges,
                            i18n: "EN"
                          },
                          on: {
                            selected: function($event) {
                              return _vm.selectRange($event)
                            }
                          },
                          model: {
                            value: _vm.range,
                            callback: function($$v) {
                              _vm.range = $$v
                            },
                            expression: "range"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          { attrs: { size: "sm", variant: "primary" } },
                          [
                            _c("i", {
                              staticClass: "icon-fa icon-fa-calendar-check-o"
                            })
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isXl
                  ? _c(
                      "b-input-group",
                      { key: _vm.dateRange },
                      [
                        _c("div"),
                        _vm._v(" "),
                        _c(
                          "b-input-group-append",
                          [
                            _c("datepicker", {
                              staticClass: "date dateLeft",
                              attrs: {
                                "input-class": "form-control dateFrom",
                                "monday-first": "",
                                size: "sm",
                                language: _vm.ru,
                                placeholder: "С:"
                              },
                              model: {
                                value: _vm.range.start,
                                callback: function($$v) {
                                  _vm.$set(_vm.range, "start", $$v)
                                },
                                expression: "range.start"
                              }
                            }),
                            _vm._v(" "),
                            _c("datepicker", {
                              staticClass: "date dateRight",
                              attrs: {
                                "input-class": "form-control dateTo",
                                "monday-first": "",
                                size: "sm",
                                language: _vm.ru,
                                placeholder: "По:"
                              },
                              model: {
                                value: _vm.range.end,
                                callback: function($$v) {
                                  _vm.$set(_vm.range, "end", $$v)
                                },
                                expression: "range.end"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
              [
                _c(
                  "v-select",
                  {
                    attrs: {
                      options: _vm.selectOffers,
                      filter: _vm.filterOffers,
                      required: "",
                      label: "title",
                      placeholder: "Оффер",
                      multiple: ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "option",
                          fn: function(option) {
                            return [
                              _c("span", [
                                _vm._v(
                                  "(" +
                                    _vm._s(option.id) +
                                    ") " +
                                    _vm._s(option.title)
                                )
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1477995661
                    ),
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "no-options" }, slot: "no-options" },
                      [_vm._v("Совпадений не найдено.")]
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
              [
                _c(
                  "v-select",
                  {
                    attrs: {
                      options: _vm.sources,
                      required: "",
                      label: "title",
                      placeholder: "Источник",
                      multiple: ""
                    },
                    model: {
                      value: _vm.source,
                      callback: function($$v) {
                        _vm.source = $$v
                      },
                      expression: "source"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "no-options" }, slot: "no-options" },
                      [_vm._v("Совпадений не найдено.")]
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
              [
                _c(
                  "v-select",
                  {
                    attrs: {
                      options: _vm.groups,
                      required: "",
                      placeholder: "Группа",
                      multiple: ""
                    },
                    model: {
                      value: _vm.group,
                      callback: function($$v) {
                        _vm.group = $$v
                      },
                      expression: "group"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "no-options" }, slot: "no-options" },
                      [_vm._v("Совпадений не найдено.")]
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.$currentUser.role == "admin" ||
            _vm.$currentUser.role == "leader"
              ? _c(
                  "div",
                  { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
                  [
                    _c(
                      "v-select",
                      {
                        attrs: {
                          label: "name",
                          options: _vm.users,
                          required: "",
                          placeholder: "Медиабайер",
                          multiple: ""
                        },
                        model: {
                          value: _vm.user,
                          callback: function($$v) {
                            _vm.user = $$v
                          },
                          expression: "user"
                        }
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "no-options" }, slot: "no-options" },
                          [_vm._v("Совпадений не найдено.")]
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            this.$currentUser.department === "adkey"
              ? _c(
                  "div",
                  { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
                  [
                    _c("v-select", {
                      attrs: {
                        options: _vm.applicationOwnerOptions,
                        placeholder: "Приложение",
                        clearable: false,
                        searchable: false
                      },
                      model: {
                        value: _vm.application_owner,
                        callback: function($$v) {
                          _vm.application_owner = $$v
                        },
                        expression: "application_owner"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
              [
                _c("v-select", {
                  attrs: {
                    options: _vm.types,
                    placeholder: "Тип",
                    clearable: false,
                    searchable: false,
                    multiple: ""
                  },
                  model: {
                    value: _vm.type,
                    callback: function($$v) {
                      _vm.type = $$v
                    },
                    expression: "type"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mt-2" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-sm-5 col-md-3 col-lg-3 col-xl-2 mb-2 applyButton"
              },
              [
                _c(
                  "b-input-group",
                  [
                    _c("div"),
                    _vm._v(" "),
                    _c(
                      "b-input-group-append",
                      [
                        _c(
                          "b-btn",
                          {
                            staticClass: "mainButton",
                            staticStyle: {
                              "margin-right": "4px",
                              "border-top-left-radius": "0.2rem",
                              "border-bottom-left-radius": "0.2rem"
                            },
                            attrs: {
                              size: "sm",
                              text: "Search",
                              variant: "success"
                            },
                            on: {
                              click: function($event) {
                                return _vm.getReports(
                                  1,
                                  {
                                    sortBy: _vm.sortBy,
                                    sortDesc: _vm.sortDesc
                                  },
                                  _vm.user,
                                  _vm.search,
                                  true
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                            Применить\n                            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-btn",
                          {
                            staticClass: "mainButton",
                            attrs: { size: "sm", variant: "outline-danger" },
                            on: { click: _vm.resetFilters }
                          },
                          [_vm._v("Очистить\n                            ")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "col-sm-2 col-md-6 col-lg-6 col-xl-8 mb-2"
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-sm-5 col-md-3 col-lg-3 col-xl-2 mb-2 applyButton"
              },
              [
                _c(
                  "b-button-group",
                  { staticClass: "float-right mainButton" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-outline-success btn-sm",
                        attrs: { href: _vm.getExcelParamsString("xlsx") }
                      },
                      [_vm._v("Excel")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-outline-success btn-sm",
                        attrs: { href: _vm.getExcelParamsString("csv") }
                      },
                      [_vm._v("CSV")]
                    )
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm-12" }, [
              !_vm.isMobile
                ? _c(
                    "div",
                    [
                      _c(
                        "b-table",
                        {
                          attrs: {
                            hover: "",
                            responsive: "",
                            bordered: "",
                            small: "",
                            items: _vm.reports,
                            fields: _vm.fields,
                            "no-local-sorting": "",
                            "sort-by": _vm.sortBy,
                            busy: _vm.isBusy,
                            "sort-desc": _vm.sortDesc,
                            "sort-direction": _vm.sortDirection
                          },
                          on: {
                            "update:sortBy": function($event) {
                              _vm.sortBy = $event
                            },
                            "update:sort-by": function($event) {
                              _vm.sortBy = $event
                            },
                            "sort-changed": function($event) {
                              return _vm.getReports(1, $event, _vm.search)
                            },
                            "update:sortDesc": function($event) {
                              _vm.sortDesc = $event
                            },
                            "update:sort-desc": function($event) {
                              _vm.sortDesc = $event
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "roi",
                                fn: function(row) {
                                  return [
                                    row.item.roi !== null
                                      ? _c("div", [
                                          _vm._v(_vm._s(row.item.roi))
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    row.item.roi === null
                                      ? _c("div", [_vm._v("0.00")])
                                      : _vm._e()
                                  ]
                                }
                              },
                              {
                                key: "gm_rev",
                                fn: function(row) {
                                  return [
                                    row.item.gm_rev !== null
                                      ? _c("div", [
                                          _vm._v(_vm._s(row.item.gm_rev))
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    row.item.gm_rev === null
                                      ? _c("div", [_vm._v("0.00")])
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            691680329
                          )
                        },
                        [
                          _c("template", { slot: "table-busy" }, [
                            _c(
                              "div",
                              { staticClass: "text-center text-danger my-2" },
                              [
                                _c("b-spinner", {
                                  staticClass: "align-middle"
                                }),
                                _vm._v(" "),
                                _c("strong", [_vm._v("Загрузка...")])
                              ],
                              1
                            )
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isMobile
                ? _c(
                    "div",
                    [
                      _c(
                        "b-table",
                        {
                          attrs: {
                            hover: "",
                            responsive: "",
                            bordered: "",
                            stacked: "",
                            small: "",
                            items: _vm.reports,
                            busy: _vm.isBusy,
                            fields: _vm.fields,
                            "no-local-sorting": "",
                            "sort-by": _vm.sortBy,
                            "sort-desc": _vm.sortDesc,
                            "sort-direction": _vm.sortDirection
                          },
                          on: {
                            "update:sortBy": function($event) {
                              _vm.sortBy = $event
                            },
                            "update:sort-by": function($event) {
                              _vm.sortBy = $event
                            },
                            "sort-changed": function($event) {
                              return _vm.getReports(1, $event, _vm.search)
                            },
                            "update:sortDesc": function($event) {
                              _vm.sortDesc = $event
                            },
                            "update:sort-desc": function($event) {
                              _vm.sortDesc = $event
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "roi",
                                fn: function(row) {
                                  return [
                                    row.item.roi !== null
                                      ? _c("div", [
                                          _vm._v(_vm._s(row.item.roi))
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    row.item.roi === null
                                      ? _c("div", [_vm._v("0.00")])
                                      : _vm._e()
                                  ]
                                }
                              },
                              {
                                key: "gm_rev",
                                fn: function(row) {
                                  return [
                                    row.item.gm_rev !== null
                                      ? _c("div", [
                                          _vm._v(_vm._s(row.item.gm_rev))
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    row.item.gm_rev === null
                                      ? _c("div", [_vm._v("0.00")])
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            691680329
                          )
                        },
                        [
                          _c("template", { slot: "table-busy" }, [
                            _c(
                              "div",
                              { staticClass: "text-center text-danger my-2" },
                              [
                                _c("b-spinner", {
                                  staticClass: "align-middle"
                                }),
                                _vm._v(" "),
                                _c("strong", [_vm._v("Загрузка...")])
                              ],
                              1
                            )
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-6 col-sm-6" }, [
              _c(
                "div",
                { attrs: { role: "status", "aria-live": "polite" } },
                [
                  _vm._v("Количество строк:\n                    "),
                  _c(
                    "b-form-select",
                    {
                      staticStyle: { width: "70px" },
                      attrs: { size: "sm" },
                      on: {
                        change: function($event) {
                          return _vm.getReports()
                        }
                      },
                      model: {
                        value: _vm.pageSize,
                        callback: function($$v) {
                          _vm.pageSize = $$v
                        },
                        expression: "pageSize"
                      }
                    },
                    [
                      _c("option", { domProps: { value: 25 } }, [_vm._v("25")]),
                      _vm._v(" "),
                      _c("option", { domProps: { value: 50 } }, [_vm._v("50")]),
                      _vm._v(" "),
                      _c("option", { domProps: { value: 75 } }, [_vm._v("75")]),
                      _vm._v(" "),
                      _c("option", { domProps: { value: 100 } }, [
                        _vm._v("100")
                      ]),
                      _vm._v(" "),
                      _c("option", { domProps: { value: 150 } }, [
                        _vm._v("150")
                      ]),
                      _vm._v(" "),
                      _c("option", { domProps: { value: 200 } }, [
                        _vm._v("200")
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { attrs: { role: "status", "aria-live": "polite" } }, [
                _vm._v("Записей на странице: "),
                _vm.reports && _vm.reports.length
                  ? _c("span", [_vm._v(_vm._s(_vm.reports.length - 2))])
                  : _vm._e(),
                !_vm.reports ? _c("span", [_vm._v("0")]) : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { attrs: { role: "status", "aria-live": "polite" } }, [
                _vm._v("Всего записей: "),
                _vm.pager && _vm.pager.total
                  ? _c("span", [_vm._v(_vm._s(_vm.pager.total))])
                  : _vm._e(),
                !_vm.pager || !_vm.pager.total
                  ? _c("span", [_vm._v("0")])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-6" }, [
              _c("div", { staticClass: "float-right" }, [
                _c("nav", { attrs: { "aria-label": "Page navigation" } }, [
                  _c(
                    "ul",
                    { staticClass: "pagination justify-content-center" },
                    [
                      _c("b-pagination", {
                        attrs: {
                          size: "sm",
                          "total-rows": _vm.pager.total,
                          "per-page": _vm.pager.per_page
                        },
                        on: {
                          change: function($event) {
                            return _vm.getReports(
                              $event,
                              { sortBy: _vm.sortBy, sortDesc: _vm.sortDesc },
                              _vm.search
                            )
                          }
                        },
                        model: {
                          value: _vm.pager.current_page,
                          callback: function($$v) {
                            _vm.$set(_vm.pager, "current_page", $$v)
                          },
                          expression: "pager.current_page"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h3", { staticClass: "page-title" }, [_vm._v("Отчёт по источникам")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-464fb557", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-464fb557","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/front/SourcesReport.vue
// module id = 983
// module chunks = 0